<template>
  <div class="container">
    <video
      id="video"
      width="3rem"
      height="3rem"
      preload
      autoplay
      loop
      muted
    ></video>
    <canvas id="canvas" width="3rem" height="3rem"></canvas>
    <!-- 顶部导航 -->
    <div class="navbar">
      <img src="../../../static/images/close2.png" @click="back" />
      <div>采集照片</div>
      <div style="width: 0.16rem"></div>
    </div>
    <!-- 主体采集 -->
    <div class="main">
      <span>示例图</span>
      <img src="../../../static/images/avatar.png" alt="" />
      <div class="distroy">
        <p>1、请正对手机摄像头，按照上图示例进行采集；</p>
        <p>2、照片仅可采集一次，采集成功后，方可进行学习；</p>
      </div>
      <button type="button" @click="submit" style="font-size: 3vw">
        提取照片</button
      ><br />
      <button
        type="button"
        name="button"
        @click="checkFace"
        style="font-size: 3vw"
      >
        检测人脸</button
      ><br />
      <button
        type="button"
        name="button"
        @click="getCompetence"
        style="font-size: 3vw"
      >
        打开摄像头</button
      ><br />
      <button type="button" name="button" @click="de" style="font-size: 3vw">
        停</button
      ><br />
      <!-- <el-button type="primary" @click="getCompetence">采集照片</el-button> -->
      <div class="action">
        <div class="action-inside">拍照</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CollectPicture",
  data() {
    return {};
  },
  methods: {
    checkFace() {},
    submit() {},
    getCompetence() {
      var _this = this;
      this.thisCancas = document.getElementById("canvas");
      this.thisContext = this.thisCancas.getContext("2d");
      this.thisVideo = document.getElementById("video");
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia;
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = {
        audio: false,
        video: {
          width: this.videoWidth,
          height: this.videoHeight,
          transform: "scaleX(-1)",
        },
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in _this.thisVideo) {
            _this.thisVideo.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream);
          }
          _this.thisVideo.onloadedmetadata = function (e) {
            _this.thisVideo.play();
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    de() {
      // 停止侦测
      this.trackerTask.stop();
      // 关闭摄像头
      this.trackerTask.closeCamera();
    },
    destroyed() {},
    // 关闭按钮
    back() {
      this.$router.go(-1); //返回上一层
    },

    getInfoMsg(type) {
      console.log(type);
    },
    backNative() {
      console.log("监听到了");
      //点击物理返回键要执行的操作
      window.location.href = "backtonative.html";
    },
    // ---------------禁止拖拽返回-------------------
    getInfoMsg(type) {
      console.log(type);
    },
    changekemu(index) {
      this.$data.showType = index;
    },
    gotochengjidanpage() {
      this.$router.push({
        name: "score",
        query: {
          userid: "c777390cfedd6d082979fe1e38bb74ac",
          id: 1,
          km: "kmy",
          cx: "xc",
          appid: "123456",
        },
      });
    },
    toVipList() {
      this.$router.push({
        name: "jjtk",
        query: {
          userid: "c777390cfedd6d082979fe1e38bb74ac",
          id: 1,
          km: "kmy",
          cx: "xc",
          appid: "123456",
        },
      });
    },
    gotolianxipage() {
      this.$router.push({
        name: "zjlx",
        query: { userid: 120934, id: 1, km: "kmy", cx: "xc" },
      });
    },
    gotopage() {
      // this.$router.push({
      //   name: "lianxidatidanxuan",
      //   params: { showType: this.$data.showType, id: 2,userid:1 }
      // });
      let km = 1;
      this.showType === 1 ? (km = "kmy") : (km = "kms");
      this.$router.push({
        name: "sxlx",
        query: {
          userid: this.$route.query.userid,
          id: 1,
          km: km,
          cx: "xc",
          appid: this.$route.query.appid,
        },
      });
    },
    gototixingxuanzepage() {
      this.$router.push({
        name: "tixingxuanze",
        params: { name: "item", id: 1 },
      });
    },
    gotowrongandcollectpage() {
      this.$router.push({
        name: "ctj",
        query: { userid: 120934, id: 1, km: "kmy", cx: "xc" },
      });
    },
  },
  afterDestory() {
    document.documentElement.style.fontSize = "";
  },
  mounted() {
    // ---------------禁止拖拽返回-----------------
    // 如果支持 popstate （一般移动端都支持）
    if (window.history && window.history.pushState) {
      // 往历史记录里面添加一条新的当前页面的url
      history.pushState(null, null, document.URL);
      // 给 popstate 绑定一个方法 监听页面刷新
      window.addEventListener("popstate", this.backNative, false); //false阻止默认事件
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.backNative, false); //false阻止默认事件
  },
  created() {
    document.documentElement.style.fontSize = "625%";
    // console.log(this.param.licence_id);
    // this.userAuth()
    var info = localStorage.getItem("ke1total");
    if (info) {
      this.$data.ke1 = info;
    } else {
      this.getInfoMsg(1);
    }
    var info4 = localStorage.getItem("ke4total");
    if (info4) {
      this.$data.ke4 = info4;
    } else {
      this.getInfoMsg(4);
    }
    // console.log = function () {
    // };
  },
};
</script>

<style lang="scss" scoped>
html {
  font-size: 625%;
}
.container {
  font-size: 0.1rem;
  // 顶部导航
  .navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 0.64rem;
    padding: 0 0.16rem;
    img {
      width: 0.16rem;
      height: 0.16rem;
    }
  }
  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.16rem;
    span {
      margin-top: 0.16rem;
      text-align: center;
      color: rgb(250, 54, 120);
    }
    img {
      margin: 0.16rem 0;
      width: 70%;
      height: 3.2rem;
      border: 0.016rem solid #ccc;
    }
    .destroy {
      text-align: left;
    }
    .el-button {
      margin-top: 0.32rem;
      width: 80%;
    }
    .action {
      width: 0.64rem;
      height: 0.64rem;
      border-radius: 0.64rem;
      background: rgb(54, 109, 187);
      .action-inside {
        margin: 0.04rem auto;
        width: 0.48rem;
        height: 0.48rem;
        border-radius: 0.48rem;
        border: 0.04rem solid #fff;
        background: rgb(104, 159, 234);
        line-height: 0.48rem;
        text-align: center;
      }
    }
  }
}
</style>
